import React, { Fragment } from 'react';

import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { MuiDivider } from './MuiDivider';

const PageHeader = ({ title, ...props }) => {
	return (
		<Fragment>
			<Typography variant={'h5'} component={'h1'} {...props}>
				{title}
			</Typography>
			<MuiDivider />
		</Fragment>
	);
};

PageHeader.propTypes = {
	title: PropTypes.any,
};

export { PageHeader };
